document.addEventListener("DOMContentLoaded", () => {
  let lenis;

  const initSmoothScrolling = () => {
    lenis = new Lenis({
      lerp: 0.1, // Lower values create a smoother scroll effect
      smoothWheel: true,
    });

    lenis.on("scroll", () => ScrollTrigger.update());
    const scrollFn = (time) => {
      lenis.raf(time);
      requestAnimationFrame(scrollFn);
    };
    requestAnimationFrame(scrollFn);
  };

  // Initialize smooth scrolling for desktop
  if (window.innerWidth > 768 && getBrowserInfo() !== "Safari") {
    initSmoothScrolling();
  }
  console.log(getBrowserInfo())

  // Create scroll lock utilities and expose them globally
  window.scrollLock = {
    disable: function() {
      // Stop Lenis if it's initialized
      if (lenis) {
        lenis.stop();
      }
      
      // Use body-scroll-lock if available
      if (window.bodyScrollLock && window.bodyScrollLock.disableBodyScroll) {
        window.bodyScrollLock.disableBodyScroll(document.body);
      }
    },
    
    enable: function() {
      // Restart Lenis if it's initialized
      if (lenis) {
        lenis.start();
      }
      
      // Use body-scroll-lock if available
      if (window.bodyScrollLock && window.bodyScrollLock.enableBodyScroll) {
        window.bodyScrollLock.enableBodyScroll(document.body);
      }
    }
  };
});



function getBrowserInfo() {
  const ua = navigator.userAgent;

  if (ua.includes("Chrome") && !ua.includes("Edg") && !ua.includes("OPR"))
    return "Google Chrome";
  if (ua.includes("Safari") && !ua.includes("Chrome"))
    return "Safari";
  if (ua.includes("Firefox"))
    return "Mozilla Firefox";
  if (ua.includes("Edg"))
    return "Microsoft Edge";
  if (ua.includes("OPR") || ua.includes("Opera"))
    return "Opera";

  return "Unknown Browser";
}